<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom"></div>
        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <header-partial :domain="domain" />

                <div class="page-block">
                    <technical-management-tabs :step="5" :domain="domain" :service="firstServiceForDomain" />

                    <vps-overview
                        v-if="servers && service"
                        :domain="domain"
                        :subscription="service"
                        :servers="servers"
                    />

                    <div v-else class="page-block__item-wrapper">
                        {{ trans('page.vps.no-vps') }}
                    </div>

                    <div class="page-block__item-wrapper">
                        <div class="layout | u-text-right">
                            <div class="layout__item u-1/4-desk">
                                <customer-router-link :to="{ name: 'orderVpsSelect', params: { domain: domain } }">
                                    <button type="button" class="btn btn--ghost btn--ghost-full-width" dusk="order-vps">
                                        {{ trans('order.vps-order') }}
                                    </button>
                                </customer-router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { VpsOverview } from 'relapp-vps';
import { HeaderPartial, serviceMixin, servicesPageMixin } from 'relapp-technical-management';
import { pageLoadingStatusMixin } from 'relapp-loading';
import { apiMixin } from 'relapp-api';
import VpsApi from 'relapp-vps/src/services/api/vps';
import { mapActions, mapGetters } from 'vuex';

export default {
    components: {
        HeaderPartial,
        VpsOverview
    },
    mixins: [serviceMixin, servicesPageMixin, pageLoadingStatusMixin, apiMixin],
    methods: {
        ...mapActions({
            setVpsDomain: 'vps/setDomain'
        })
    },
    computed: {
        ...mapGetters({
            servers: 'vps/servers'
        })
    },
    /**
     * Get the data with the servicetype vps
     *
     * @return {object}
     */
    data() {
        return {
            serviceType: 'vps'
        };
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.setVpsDomain(this.routeParams);
        this.getServices();
        // Fetch VPS
        VpsApi.get(this.routeParams, true).then(() => this.finishLoading());
    },
    /**
     * Get the meta info for the page.
     *
     * @return {object}
     */
    metaInfo() {
        return {
            title: trans('page.vps.title', { domain: this.domain })
        };
    }
};
</script>
